import React, { useEffect, useState } from 'react'
import { Container} from './styled'
import { useParams } from 'react-router-dom'
import InternalHeader from '../../general/internalHeader/view'
import VenueListItem from '../venueListItem/view'
import { getVenues, createVenue } from 'api'
import { Grid, Button, Modal, TextField, Box, Typography, IconButton, Snackbar, Alert, MenuItem, Divider } from '@mui/material'
import { useNavigate } from 'react-router'
import coworking from 'assets/images/coworking.jpg'
import noAvatar from '../../../../assets/images/no-avatar.png'
import { useProfile } from 'context';
import { getAvatarUrl } from '../../../../api/utils';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next'


const VenuesManage = () => {
  const { t } = useTranslation()
  const { profile } = useProfile();
  const params = useParams()
  const { slug } = params
  const [venues, setVenues] = useState([])
  const [openAddModal, setOpenAddModal] = useState(false)
  const [venueName, setVenueName] = useState('')
  const [selectedClient, setSelectedClient] = useState('')
  const [newClientName, setNewClientName] = useState('')
  const [newClientEmail, setNewClientEmail] = useState('')
  const [isNewClient, setIsNewClient] = useState(false)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')
  const [snackbarSeverity, setSnackbarSeverity] = useState('success')

  const navigate = useNavigate()
  function getVenuesInfo() {
    getVenues(slug).then(r => {
      setVenues(r.venues)
    })
      .catch(console.error)
  }

  function navigateVenue(venue) {    
    navigate(`/manage/venue/${venue?.slug}`);      
    //window.location.href = '/login'
  }

  function headerActionMethod() {
    // Only open modal if user is a Super Admin
    if (profile?.staff?.is_staff && profile?.staff?.role === 'SA') {
      // Set default client selection
      if (profile?.staff?.clients?.length === 1) {
        // If only one client, select it
        setSelectedClient(profile?.staff?.clients[0]?.slug);
      } else if (profile?.staff?.current_client?.slug) {
        // If multiple clients, select current_client
        setSelectedClient(profile?.staff?.current_client?.slug);
      } else if (profile?.staff?.clients?.length > 0) {
        // Fallback to first client if no current_client
        setSelectedClient(profile?.staff?.clients[0]?.slug);
      }
      
      setIsNewClient(false);
      setNewClientName('');
      setNewClientEmail('');
      setOpenAddModal(true);
    }
  }

  const handleCreateVenue = () => {
    if (!venueName.trim()) {
      setSnackbarSeverity('error');
      setSnackbarMessage('Venue name cannot be empty');
      setSnackbarOpen(true);
      return;
    }

    if (isNewClient) {
      if (!newClientName.trim()) {
        setSnackbarSeverity('error');
        setSnackbarMessage('Client name cannot be empty');
        setSnackbarOpen(true);
        return;
      }
      
      if (!newClientEmail.trim()) {
        setSnackbarSeverity('error');
        setSnackbarMessage('Client email cannot be empty');
        setSnackbarOpen(true);
        return;
      }

      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(newClientEmail)) {
        setSnackbarSeverity('error');
        setSnackbarMessage('Please enter a valid email address');
        setSnackbarOpen(true);
        return;
      }
    } else if (!selectedClient) {
      setSnackbarSeverity('error');
      setSnackbarMessage('Please select a client');
      setSnackbarOpen(true);
      return;
    }

    const venueData = isNewClient 
      ? { 
          name: venueName,
          client_name: newClientName,
          client_email: newClientEmail
        }
      : { 
          name: venueName,
          client_slug: selectedClient
        };

    createVenue(venueData)
      .then(response => {
        setOpenAddModal(false);
        setVenueName('');
        setSelectedClient('');
        setNewClientName('');
        setNewClientEmail('');
        setIsNewClient(false);
        getVenuesInfo();
        setSnackbarSeverity('success');
        setSnackbarMessage('Venue created successfully!');
        setSnackbarOpen(true);
      })
      .catch(error => {
        console.error('Error creating venue:', error);
        setSnackbarSeverity('error');
        setSnackbarMessage('Failed to create venue. Please try again.');
        setSnackbarOpen(true);
      });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    getVenuesInfo(true)

  }, [])


  const avatar = getAvatarUrl(profile, noAvatar);
  const isSuperAdmin = profile?.staff?.is_staff && profile?.staff?.role === 'SA';

  return (
    <Container>
      {/* Global toolbar */}
      {/* Community header */}
      <InternalHeader 
        title={'Your spaces'} 
        subtitle={''} 
        avatar={avatar} 
        background={coworking} 
        actionTitle={isSuperAdmin ? 'Add Space' : ''}
        actionMethod={headerActionMethod} 
      />
      
      {/* Add Venue Button (visible only on smaller screens where the header action might not be visible) */}
      {isSuperAdmin && (
        <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end', mb: 2 }}>
          <Button 
            variant="contained" 
            color="primary"
            sx={{ color: 'white' }} 
            onClick={() => setOpenAddModal(true)}
            startIcon={<AddIcon />}
          >
            {t('Add Space')}
          </Button>
        </Box>
      )}

      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        {venues?.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <VenueListItem venue={item} selectVenue={(item) => navigateVenue(item)} />
          </Grid>
        ))}
      </Grid>

      {/* Add Venue Modal */}
      <Modal
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
        aria-labelledby="add-venue-modal-title"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: { xs: 2, sm: 4 }
        }}
      >
        <Box
          sx={{
            backgroundColor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: { xs: 3, sm: 4 },
            maxWidth: '500px',
            width: '100%',
            position: 'relative'
          }}
        >
          <IconButton
            onClick={() => setOpenAddModal(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'text.secondary'
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <Typography
            variant="h5"
            component="h2"
            sx={{ fontWeight: 500, mb: 3 }}
          >
            {t('Add New Space')}
          </Typography>
          
          <TextField
            required
            label={t('Space Name')}
            value={venueName}
            onChange={(e) => setVenueName(e.target.value)}
            fullWidth
            variant="outlined"
            margin="normal"
            autoFocus
          />
          
          {/* Client Selector */}
          {profile?.staff?.clients?.length > 0 && (
            <TextField
              select
              required
              label={t('Client')}
              value={isNewClient ? 'new' : selectedClient}
              onChange={(e) => {
                if (e.target.value === 'new') {
                  setIsNewClient(true);
                  setSelectedClient('');
                } else {
                  setIsNewClient(false);
                  setSelectedClient(e.target.value);
                }
              }}
              fullWidth
              variant="outlined"
              margin="normal"
              helperText={t('Select the client for this space')}
            >
              {profile?.staff?.clients.map((client) => (
                <MenuItem key={client.slug} value={client.slug}>
                  {client.name}
                </MenuItem>
              ))}
              <Divider sx={{ my: 1 }} />
              <MenuItem value="new" sx={{ color: 'primary.main', fontWeight: 500 }}>
                <AddIcon fontSize="small" sx={{ mr: 1 }} /> {t('Create new client')}
              </MenuItem>
            </TextField>
          )}
          
          {/* New Client Fields */}
          {isNewClient && (
            <Box sx={{ mt: 2, p: 2, bgcolor: 'background.default', borderRadius: 1 }}>
              <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 500 }}>
                {t('New Client Information')}
              </Typography>
              
              <TextField
                required
                label={t('Client Name')}
                value={newClientName}
                onChange={(e) => setNewClientName(e.target.value)}
                fullWidth
                variant="outlined"
                margin="normal"
              />
              
              <TextField
                required
                label={t('Contact Email')}
                value={newClientEmail}
                onChange={(e) => setNewClientEmail(e.target.value)}
                fullWidth
                variant="outlined"
                margin="normal"
                type="email"
              />
            </Box>
          )}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 2,
              mt: 4
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                setOpenAddModal(false);
                setVenueName('');
                setSelectedClient('');
                setNewClientName('');
                setNewClientEmail('');
                setIsNewClient(false);
              }}
              sx={{ borderRadius: '20px' }}
            >
              {t('Cancel')}
            </Button>
            <Button
              variant="contained"
              onClick={handleCreateVenue}
              color="primary"
              sx={{ borderRadius: '20px' }}
              disabled={!venueName.trim() || (!isNewClient && !selectedClient) || 
                      (isNewClient && (!newClientName.trim() || !newClientEmail.trim()))}
            >
              {t('Create Space')}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  )
}

VenuesManage.propTypes = {}

export default VenuesManage
